'use strict';


export default function() {
	return function(users, role) {
		return users.map(function(user) {
			return {user: user.uuid, role: role};
		});
	}
}
